import React from "react";

const ruBreadcrumbsMapper = (path) => {
    return urls[path];
}

const theory = 'school.breadcrumbsAndTitle.theory';
const lecture = 'school.breadcrumbsAndTitle.lecture';
const creating = 'school.breadcrumbsAndTitle.creating';
const editing = 'school.breadcrumbsAndTitle.editing';

const urls = {
    '/school/theory/group/create/': [
        {ru: theory, link: '/school/theory'},
        {ru: creating, link: ''},
    ],
    '/school/theory/group/edit/:url': [
        {ru: theory, link: '/school/theory'},
        {ru: ':url', link: '/school/theory/group/view/:url'},
        {ru: editing, link: ''}
    ],
    '/school/theory/group/view/:url': [
        {ru: theory, link: '/school/theory'},
        {ru: ':url', link: ''},
    ],
    '/school/theory': [
        {ru: theory, link: ''},
    ],

    '/school/lectures/group/create/': [
        {ru: lecture, link: '/school/lectures'},
        {ru: creating, link: ''},
    ],
    '/school/lectures/group/edit/:url': [
        {ru: lecture, link: '/school/lectures'},
        {ru: ':url', link: '/school/lectures/group/view/:url'},
        {ru: editing, link: ''}
    ],
    '/school/lectures/group/view/:url': [
        {ru: lecture, link: '/school/lectures'},
        {ru: ':url', link: ''},
    ],
    '/school/lectures/:url': [
        {ru: lecture, link: '/school/lectures'},
        {ru: ':url', link: ''},
    ],
    '/school/lectures': [
        {ru: lecture, link: '/school/lectures'},
    ],

    '/school/practices/view/:url/:arrival_url': [
        {ru: ':type', link: '/school/practices/:type'},
        {ru: ':url', link: '/school/practices/view/:url'},
        {ru: ':arrival_url', link: ''},
    ],
    '/school/practices/view/:url': [
        {ru: ':type', link: '/school/practices/:type'},
        {ru: ':url', link: ''},

    ],
    '/school/practices/:type/edit/:url': [
        {ru: ':type', link: '/school/practices/:type'},
        {ru: ':url', link: '/school/practices/view/:url'},
        {ru: editing, link: '/school/practices/view/:url'},
    ],
    '/school/practices/:type/edit/': [
        {ru: ':type', link: '/school/practices/:type'},
        {ru: 'school.breadcrumbsAndTitle.creating', link: ''},
    ],
    '/school/practices/:type': [
        {ru: ':type', link: ''},
    ],
}

export default ruBreadcrumbsMapper;